import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import SubscriberError from '../Shared/SubscriberError/SubscriberError';
import { Container, Col, Row } from 'reactstrap';
import { setTitle, pageLoaded } from '../fundialSlice';
import { hideAppLoader } from '../../../Shared/Loader/LoaderSlice';

const ErrorPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    props.hideAppLoader();

    if (runSideEffects()) {
      props.setTitle({titleBold: "בחירת המתנה נעימה" , titleRegular: ""})
      // props.pageLoaded();
    }
  }, []);

  function view() {
    return (
      <Row className="justify-content-md-center">
        <Col xs='12' sm='12' md='6'>
            <SubscriberError/>
        </Col>
      </Row>
    )
  }


  return (
    <div className='fundial-error-page'>
      {view()}
    </div>
  );
};



const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
  setTitle, 
  hideAppLoader,
  pageLoaded
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);